import { render } from "./Basket.vue?vue&type=template&id=16e1bd04&scoped=true"
import script from "./Basket.vue?vue&type=script&lang=js"
export * from "./Basket.vue?vue&type=script&lang=js"

import "./Basket.vue?vue&type=style&index=0&id=16e1bd04&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src801691255/src/serverlesspressoV3/frontends/vue-order-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e1bd04"]])

export default __exports__